import { render, staticRenderFns } from "./ActionIcon.vue?vue&type=template&id=af63f080&"
import script from "./ActionIcon.vue?vue&type=script&lang=js&"
export * from "./ActionIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports